import { DecimalPipe } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';

export enum enProgressDisplayText {
  None,
  Percent,
  ValueAndMax,
  ValueOnly
};

@Component({
  selector: 'paf-round-progress-svg',
  templateUrl: './paf-round-progress-svg.component.html',
  styleUrls: ['./paf-round-progress-svg.component.scss'],
})
export class PafRoundProgressSvgComponent  implements OnChanges {
  @Input() value: number = 0;        // entre 0 et 100
  @Input() max: number = 100;        // entre 0 et 100
  @Input() width: number = 50;       // rayon du demi-cercle
  @Input() height?: number;       // rayon du demi-cercle
  @Input() stroke: number = 10;        // épaisseur du trait
  @Input() displayMode: enProgressDisplayText = enProgressDisplayText.None;    // afficher %
  @Input() color: string = '#007bff';  // couleur de l'arc
  get percent(): number {
    if (this.max <= 0) return 0;
    return (this.value / this.max) * 100;
  }

  readonly enProgressDisplayText = enProgressDisplayText;

  arcPath = '';
  circumference = 0;
  strokeDashoffset = 0;

  get circleHeight():number {
    return this.height || this.width / 2;
  }
  ngOnChanges() {
    // Arc d’un demi-cercle
    this.arcPath = `M ${this.stroke / 2},${this.circleHeight} 
                    A ${this.circleHeight - this.stroke / 2},${this.circleHeight - this.stroke / 2} 0 0,1 
                      ${this.width - this.stroke / 2},${this.circleHeight}`;

    this.circumference = Math.PI * (this.circleHeight - this.stroke / 2);
    const percentValue = Math.min(Math.max(this.percent, 0), 100);
    this.strokeDashoffset =
      this.circumference - (percentValue / 100) * this.circumference;
  }
}